"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRelatedRegionClickLog = exports.useRelatedKeywordClickLog = exports.useRkRelatedKeywordClickLog = exports.useRegionKeywordClickLog = exports.useAutoCpLog = exports.useSearchClickLog = exports.useListMapLog = exports.useListLog = exports.useSearchLog = exports.useRecomClickLog = exports.useRecomDetailLog = exports.useRecomLog = void 0;
const logDataParser_1 = require("../modules/log/logDataParser");
const checkUserAgent_1 = require("../utils/checkUserAgent");
const cleanObject_1 = __importDefault(require("../utils/cleanObject"));
const useRecomLog = (user) => {
    const sendLog = ({ recom_json, recom_target_region, referer, }) => {
        return (0, logDataParser_1.recomSender)({
            user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "recom",
            recom_json: (0, cleanObject_1.default)(recom_json),
            recom_target_region,
            referer,
            test: false,
        });
    };
    return sendLog;
};
exports.useRecomLog = useRecomLog;
const useRecomDetailLog = (user) => {
    const sendLog = ({ from, recom_detail_json, recom_target_region, }) => {
        return (0, logDataParser_1.recomDetailSender)({
            user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "recom_detail",
            from,
            recom_detail_json: (0, cleanObject_1.default)(recom_detail_json),
            recom_target_region: recom_target_region,
            test: false,
        });
    };
    return sendLog;
};
exports.useRecomDetailLog = useRecomDetailLog;
const useRecomClickLog = (user) => {
    const sendLog = ({ recom_click_json, from, }) => {
        return (0, logDataParser_1.recomClickSender)({
            user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "recom_click",
            recom_click_json: (0, cleanObject_1.default)(recom_click_json),
            from,
            test: false,
        });
    };
    return sendLog;
};
exports.useRecomClickLog = useRecomClickLog;
const useSearchLog = (user) => {
    const sendLog = ({ query_json, search_rn_result, referer, }) => {
        return (0, logDataParser_1.querySender)({
            user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "search",
            query_json: (0, cleanObject_1.default)(query_json),
            search_rn_result: (0, cleanObject_1.default)(search_rn_result),
            referer,
            test: false,
        });
    };
    return sendLog;
};
exports.useSearchLog = useSearchLog;
const useListLog = (user) => {
    const sendLog = ({ query_json, search_rn_result, referer, }) => {
        return (0, logDataParser_1.querySender)({
            user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "list",
            query_json: (0, cleanObject_1.default)(query_json),
            search_rn_result: (0, cleanObject_1.default)(search_rn_result),
            referer,
            test: false,
        });
    };
    return sendLog;
};
exports.useListLog = useListLog;
const useListMapLog = (user) => {
    const sendLog = ({ query_json, search_rn_result, referer, }) => {
        return (0, logDataParser_1.querySender)({
            user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "listmap",
            query_json: (0, cleanObject_1.default)(query_json),
            search_rn_result: (0, cleanObject_1.default)(search_rn_result),
            referer,
            test: false,
        });
    };
    return sendLog;
};
exports.useListMapLog = useListMapLog;
const useSearchClickLog = (user) => {
    const sendLog = ({ search_click_json, }) => {
        return (0, logDataParser_1.searchClickSender)({
            user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "search_click",
            search_click_json: (0, cleanObject_1.default)(search_click_json),
            test: false,
        });
    };
    return sendLog;
};
exports.useSearchClickLog = useSearchClickLog;
const useAutoCpLog = (user) => {
    const sendLog = ({ inputQuery, v_rid, typeSub, }) => {
        return (0, logDataParser_1.autocpSender)({
            user: user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "autocp",
            typeSub,
            inputQuery,
            v_rid,
        });
    };
    return sendLog;
};
exports.useAutoCpLog = useAutoCpLog;
const useRegionKeywordClickLog = (user) => {
    const sendLog = ({ region_name, keyword, is_region_click, }) => {
        const region_keyword_click_json = {
            region_name,
            keyword,
            is_region_click
        };
        return (0, logDataParser_1.regionKeywordClickSender)({
            user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "region_keyword_click",
            region_keyword_click_json: (0, cleanObject_1.default)(region_keyword_click_json),
            test: false,
        });
    };
    return sendLog;
};
exports.useRegionKeywordClickLog = useRegionKeywordClickLog;
const useRkRelatedKeywordClickLog = (user) => {
    const sendLog = ({ region_name, keyword, origin_keyword, }) => {
        const rk_related_keyword_click_json = {
            region_name,
            keyword,
            origin_keyword
        };
        return (0, logDataParser_1.rkRelatedKeywordClickSender)({
            user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "rk_related_keyword_click",
            rk_related_keyword_click_json: (0, cleanObject_1.default)(rk_related_keyword_click_json),
            test: false,
        });
    };
    return sendLog;
};
exports.useRkRelatedKeywordClickLog = useRkRelatedKeywordClickLog;
const useRelatedKeywordClickLog = (user) => {
    const sendLog = ({ keyword, origin_keyword, }) => {
        const related_keyword_click_json = {
            keyword,
            origin_keyword
        };
        return (0, logDataParser_1.relatedKeywordClickSender)({
            user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "related_keyword_click",
            related_keyword_click_json: (0, cleanObject_1.default)(related_keyword_click_json),
            test: false,
        });
    };
    return sendLog;
};
exports.useRelatedKeywordClickLog = useRelatedKeywordClickLog;
const useRelatedRegionClickLog = (user) => {
    const sendLog = ({ region_name, keyword, related_keyword, is_region_click, }) => {
        const related_region_click_json = {
            region_name,
            keyword,
            related_keyword,
            is_region_click
        };
        return (0, logDataParser_1.relatedRegionClickSender)({
            user,
            device: (0, checkUserAgent_1.checkDevice)(),
            logType: "related_region_click",
            related_region_click_json: (0, cleanObject_1.default)(related_region_click_json),
            test: false,
        });
    };
    return sendLog;
};
exports.useRelatedRegionClickLog = useRelatedRegionClickLog;
